import * as R from 'ramda';

export const getUrlExtension = ( url: string ) => {
  if (R.isNil(url)) {
    return url;
  }

  return url.split(/[#?]/)?.[0]?.split('.')?.pop()?.trim();
}